import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
  Checkbox,
  ListItemText,
  ListSubheader,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface FilterOption {
  label: string;
  value?: string;
}

interface FilterSelectProps {
  filterOptions: FilterOption[];
  currentFilter: string;
  onFilterChange: (filter: string) => void;
  className?: string;
}

export default function FilterSelect({
  filterOptions,
  currentFilter,
  className,
  onFilterChange,
}: FilterSelectProps) {
  const { t } = useTranslation('common');
  const [selectedFilters, setSelectedFilters] = React.useState<string[]>([]);

  React.useEffect(() => {
    const filters = (currentFilter || '')
      .split('&')
      .filter((val) => val !== '');
    setSelectedFilters(filters);
  }, [currentFilter]);

  const handleChange = (event: any) => {
    const values = event.target.value as string[];
    const isClear = values.findIndex((val) => val === 'clear') >= 0;
    if (isClear) {
      setSelectedFilters([]);
      onFilterChange('');
    } else {
      setSelectedFilters(values);
      onFilterChange(values.join('&'));
    }
  };

  const renderFilter = (values: any): string => {
    const count = (values as string[]).length;
    return `Filtered (${count})`;
  };

  return (
    <FormControl className={className}>
      <InputLabel id="filter-label">{t('common.filter')}</InputLabel>
      <Select
        labelId="filter-label"
        data-testid="filter-select"
        multiple
        value={selectedFilters}
        onChange={handleChange}
        input={<Input />}
        renderValue={renderFilter}>
        <MenuItem color="primary" key={'clear'} value={'clear'}>
          <Button variant="contained" fullWidth={true}>
            {t('provider.clearFilter')}
          </Button>
        </MenuItem>
        {filterOptions.map((option) =>
          option.value ? (
            <MenuItem key={option.value} value={option.value}>
              <Checkbox
                color="primary"
                checked={selectedFilters.indexOf(option.value) > -1}
              />
              <ListItemText primary={option.label} />
            </MenuItem>
          ) : (
            <ListSubheader key={option.label}>{option.label}</ListSubheader>
          ),
        )}
      </Select>
    </FormControl>
  );
}
